import type { FC, PropsWithChildren } from 'react';
import { SkipRenderOnServer } from '../../utils/SkipRenderOnServer';
import type { IPopoverProps } from './IPopoverProps';
import { ClientOnlyPopover } from './internal/ClientOnlyPopover';

export type { IPopoverProps };

/**
 * Popover component used to display content in a `modal like` view but anchored
 * to an specific element in the screen.
 *
 * Use it when you want to display a popover over a specific element in the screen.
 *
 * @example
 *
 * ```tsx
 * <div ref={anchorRef}>
 *  <button onClick={openHandler}>Open Popover</button>
 * </div>
 * <Popover anchorRef={anchorRef} isOpen={opened} onClose={closeHandler}>
 *   <Card>
 *     <p>Popover content</p>
 *   </Card>
 * </Popover>
 * ```
 */
export const Popover: FC<PropsWithChildren<IPopoverProps>> = (props) => {
  return (
    <SkipRenderOnServer>
      <ClientOnlyPopover {...props} />
    </SkipRenderOnServer>
  );
};
